export default __webpack_public_path__ + "static/media/ducted-split-air-conditioner-installation-services-500x500.4024dc06.png";